import { Card, Flex, Grid, Image } from '@zillow/constellation';
import { Heading, Modal, Text, TextButton } from '@zillow/constellation-10';

import MediumIllustrationHouse1x from '../../../../../../images/MediumIllustrationHouse@1x.png';

import { AppSelectors } from '../../../../../../selectors';
import { useSelector } from '../../../../../../selectors/useSelector';

import { StyledFlex } from '../../StyledComponents';

import type { ElementType } from 'react';

type FeatureCardProps = {
  heading: string;
  body: string;
  Icon: ElementType;
  modalContent: string;
  headingCount?: string | null;
  onClick?: (heading: string) => void;
};

const FeatureCard = ({ heading, body, Icon, modalContent, headingCount = null, onClick }: FeatureCardProps) => {
  const isDesktop = useSelector((state) => AppSelectors.makeIsScreenDesktop(state));

  const updatedHeading = headingCount ? `${headingCount} ${heading}` : heading;

  const handleClick = () => {
    if (onClick) {
      onClick(heading);
    }
  };

  return (
    <>
      <Grid display="grid" gridColumnEnd={`span ${isDesktop ? 1 : 4}`} data-testid="FeatureCard">
        <Modal
          dividers={false}
          trigger={
            <Card
              onClick={handleClick}
              appearance="borderless"
              interactive={true}
              cardElevation={1}
              cardType="secondary"
            >
              <StyledFlex>
                <Flex display="flex" justifyContent="space-between">
                  <Text textStyle="body-bold" asChild>
                    <p>{updatedHeading}</p>
                  </Text>
                  <Icon size="sm" fontColor="brand" />
                </Flex>
                <Flex display="flex" flexGrow={1}>
                  <Text asChild css={{ marginBlock: '200' }}>
                    <p>{body}</p>
                  </Text>
                </Flex>
                <Flex display="flex">
                  <TextButton textStyle="body-sm">Learn more</TextButton>
                </Flex>
              </StyledFlex>
            </Card>
          }
          body={
            <>
              <Flex display="flex" justifyContent="center" marginBottom="sm">
                <Image src={MediumIllustrationHouse1x} alt="house" />
              </Flex>
              <Heading level={4} css={{ marginBottom: '400' }}>
                {heading}
              </Heading>
              <Text>{modalContent}</Text>
            </>
          }
        />
      </Grid>
    </>
  );
};

export { FeatureCard };
